/**
 * @description 「是」或「否」Value (enum)
 */
export enum YesNoValuesEnum {
  /** 無 */
  None = '',
  /** 否 */
  No = '0',
  /** 是 */
  Yes = '1'
}
